import * as React from "react";
import HoldUtilHeader from "../../generic/holdUtilHeader";
import HoldMfUnusableRowDsk from "./holdMfUnusableRowDsk";
import HoldMfUnusableRowMob from "./holdMfUnusableRowMob";
import DeviceContext from "../../../../service/indentifyDevice";
import Sort, { eSortState, sort } from "../../../../generic/sort";
import { SearchHighLight } from "../../../../service/generic/searchHighlight";
import NoDataContainer from "../../../../generic/noDataContainer";

if (DeviceContext().isDesktop) {
	require("../../../../../assets/scss/components/toc/holdings/holdTables/holdTableDsk.scss");
} else if (DeviceContext().isTablet) {
	require("../../../../../assets/scss/components/toc/holdings/holdTables/holdTableTab.scss");
} else {
	require("../../../../../assets/scss/components/toc/holdings/holdTables/holdTableMob.scss");
}

export interface IHoldMfUnusableTableProps {
	data: Array<any>;
}

const heading = {
	companyName: "Scheme Name",
	category: "Category",
	pledgQty: "Pledged Qty",
	lockedInQty: "Locked-in Qty",
	LTP: "NAV",
	holdingValue: "Holding Value"
};

const HoldMfUnusableTable: React.FC<IHoldMfUnusableTableProps> = props => {
	// Make tableData 2D to maintain consistency with other tables
	const [filteredData, setFilteredData] = React.useState([props.data]);
	const [tableData, setTableData] = React.useState([props.data]);
	// to maintain the state of sorted column
	const [sortedColumnState, setSortedColumnState] = React.useState({ colName: null as string | null, sortState: eSortState.ASC });

	function parsePropData() {
		// deepcopy for searching, otherwise the changes happen through reference in SearchHighLight
		return props.data.map(row => ({ ...row }));
	}

	React.useEffect(() => {
		setTableData([parsePropData()]);
	}, [props.data]);

	function onSort(data: Array<Array<any>>, sortState: eSortState, colName: string) {
		setSortedColumnState({ colName, sortState });
		setTableData(data);
	}

	function sortAfterFilter(groupedData: Array<Array<any>>) {
		// if some column was sorted earlier, then sort that again
		if (sortedColumnState.colName) {
			// copy grouped data, because it will change after sorting
			// filtered data will also change with groupedData
			const copyGroupedData = groupedData.map(group => group.map(data => data));

			sort(copyGroupedData, sortedColumnState.sortState, sortedColumnState.colName, onSort);
		}
	}

	function handleSearch(filteredData: Array<Array<any>>, sText?: string | undefined) {
		// set filtered data in the beginning because this will be used while sorting
		// we don't want the <b> tag while sorting
		setFilteredData(filteredData);

		if (sText) {
			const SearchText: string = sText.toLowerCase();
			const searchKey: string = "companyName";

			// highlight the rows
			filteredData[0].forEach((row: any) => (row[searchKey] = SearchHighLight(row[searchKey], SearchText)));
		}

		setTableData(filteredData);

		sortAfterFilter(filteredData);
	}

	return (
		<>
			<HoldUtilHeader data={[parsePropData() || []]} searchKey="companyName" onDataFilter={handleSearch} onSearchClick={() => {}} />

			<div className="hold_mf_unusable_table_dsk hold_table">
				{!DeviceContext().isMobile && (
					<ul className="hdr_row">
						<li>
							<div className="col companyName">
								<Sort
									sortList={filteredData}
									sortedColName={sortedColumnState.colName}
									sortKey="companyName"
									onSort={onSort}
									colName={heading.companyName}
								/>
							</div>
							<div className="col category">{heading.category}</div>
							<div className="col pledgQty w_80">{heading.pledgQty}</div>
							<div className="col lockedInQty w_80">{heading.lockedInQty}</div>
							<div className="col ltp w_80">{heading.LTP}</div>
							<div className="col holdingValue w_90">
								<Sort
									sortList={filteredData}
									sortedColName={sortedColumnState.colName}
									sortKey="holdingValue"
									onSort={onSort}
									colName={heading.holdingValue}
								/>
							</div>
						</li>
					</ul>
				)}

				{/* If data is not there in array, then show no data container */}
				{tableData[0].length ? (
					<div className="hold_scroll_cont">
						<ul>
							{tableData[0].map((row, index) => (
								<React.Fragment key={index}>
									{!DeviceContext().isMobile ? <HoldMfUnusableRowDsk rowData={row} /> : <HoldMfUnusableRowMob rowData={row} />}
								</React.Fragment>
							))}
						</ul>
					</div>
				) : (
					<NoDataContainer txtHeading="No results found" />
				)}
			</div>
		</>
	);
};

export default HoldMfUnusableTable;
